function addInputFile() {

    let addButton = $('._js-add-input-file');
    let i         = 1;

    addButton.on('click', function(){
        let parent  = $(this).parents('._js-input-files');
        let list    = parent.find('._js-input-files-list');

        ++i;
        list.append(createInputFile(i));
    });

}

function createInputFile(id) {
    let inputFile = '<div class="input-file">' +
                        '<input class="input-file__input _js-input-file" name="file-'+id+'" type="file">' +
                        '<div class="input">' +
                            '<input class="_js-input-text" type="text" readonly="">' +
                        '</div>' +
                        '<button class="button _js-file-button" type="button">Обзор</button>' +
                    '</div>';

    return inputFile;
}